// eslint-disable-next-line import/prefer-default-export
export function findScrollParent(node: HTMLElement | null): HTMLElement | null {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  }

  return findScrollParent(node.parentNode as HTMLElement);
}

export function findAllScrollParents(node: HTMLElement | null) {
  const scrollContainers = [];
  while (node?.parentNode) {
    const scrollParent = findScrollParent(node);
    scrollContainers.push(scrollParent);
    node = scrollParent?.parentNode as HTMLElement | null;
  }
  return scrollContainers;
}
